import { render } from "./search.vue?vue&type=template&id=5718c692"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5718c692"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5718c692', __exports__)) {
    api.reload('5718c692', __exports__)
  }
  
  module.hot.accept("./search.vue?vue&type=template&id=5718c692", () => {
    api.rerender('5718c692', render)
  })

}


export default __exports__